export const P = {
  home: '/',
  news: '/news',
  enterprises: '/enterprises',
  newsExpress: '/news?type=1',
  newsDetail: (id) => `/news/${id}`,
  hall: '/hall',
  hallDetail: (id) => `/hall/${id}`,
  datasets: '/datasets',
  datasetDetail: (id) => `/datasets/${id}`,
  providers: '/providers',
  providerApply: '/providers/apply',
  providerCard: (id) => `/providers/card/${id}`,
  enterprise: (id) => `/enterprise/${id}`,
  providerDetail: (enterpriseId) => `/enterprise/${enterpriseId}`,
  demand: '/demand',
  demandApply: '/demand/apply',
  demandDetail: (id) => `/demand/${id}`,
  listingDetail: (id, kind) => (kind === 'demand' ? `/demand/${id}` : `/providers/card/${id}`),
  exchanges: '/exchanges',
  exchangeApply: '/exchanges/apply',
  map: '/map',
  mapRegion: (name) => `/map/${encodeURIComponent(name || '')}`,
  experts: '/experts',
  expertDetail: (id) => `/experts/${id}`,
  interviews: '/interviews',
  interviewDetail: (id) => `/interviews/${id}`,
  live: '/live',
  resources: '/resources',
  submitCompany: '/submit/company',
  submitExpert: '/submit/expert',
  college: '/college',
  lab: '/lab',
  about: (name) => `/about/${encodeURIComponent(name || '')}`,
  /** 锚点直达：/about#section-N，浏览器原生跳转 */
  aboutAnchor: (index) => `/about#section-${index}`,
  supplier: (id, companyId) => {
    if (companyId && String(companyId) !== String(id)) {
      return `/supplier/${id}/${companyId}`
    }
    return `/supplier/${id}`
  }
}

export const LEGACY_PATHS = [
  '/Home',
  '/HotNewsList',
  '/moreDetail',
  '/NewInfoDetail',
  '/DataChangeList',
  '/DataChangedetail',
  '/DataDemandSide',
  '/DataServiceProviderView',
  '/DataProviderDetails',
  '/DataRequirementRequest',
  '/DataTradingInfoList',
  '/DataTradingInfo',
  '/chinaIndex',
  '/ProviderMapIndex',
  '/InterViewList',
  '/InterViewDetail',
  '/UserDetailMore',
  '/UserDetailName',
  '/LiveInfoMore',
  '/IndustryInfo',
  '/AddCompanyInfo',
  '/AddExpert',
  '/College',
  '/Lab',
  '/FooterDetail'
]

export function routeId(route, ...keys) {
  const p = (route && route.params) || {}
  const list = keys.length ? keys : ['id', 'companyId', 'enterpriseId']
  for (const key of list) {
    if (p[key] != null && p[key] !== '') return p[key]
  }
  return ''
}

export function routeName(route) {
  const raw = (route && route.params && route.params.name) || ''
  try {
    return decodeURIComponent(raw)
  } catch (e) {
    return raw
  }
}

export function hasQuery(route) {
  const query = (route && route.query) || {}
  return Object.keys(query).length > 0
}

/** 允许保留查询串的正式路由（资讯页用 ?type= 记住当前 tab） */
export const QUERY_PATHS = ['/news']

export function keepsQuery(route) {
  const path = (route && route.path) || ''
  return QUERY_PATHS.indexOf(path) !== -1
}

export function dropQuery(route) {
  return {
    path: route.path,
    hash: route.hash || '',
    query: {},
    replace: true
  }
}

export function isLegacyPath(path) {
  return LEGACY_PATHS.indexOf(path) !== -1
}
